import styled from '@emotion/styled';

export const Container = styled.div`
  display: inline-grid;
  justify-items: center;
  pointer-events: all;
  user-select: none;
  cursor: pointer;

  // triangle
  &:after {
    content: '';
    width: 12px;
    height: 6px;
    background: var(--background);
    clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  }
`;
